
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dersler/[pathListSlug]",
      function () {
        return require("private-next-pages/dersler/[pathListSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dersler/[pathListSlug]"])
      });
    }
  